import React, { lazy } from 'react';

import { RouteObject } from 'react-router-dom';

const PublicOutagesMap = lazy(() => import('@pages/landing/PublicOutagesMap'));

export const PublicOutagesMapRoutes: RouteObject[] = [
  {
    path: '/map',
    element: (
      <React.Suspense>
        <PublicOutagesMap />
      </React.Suspense>
    ),
  },
];
